export enum EnvelopePersistencyFactor {
  Minutes = 1,
  Hours = 2,
  Days = 3,
}
